<template>
  <v-container v-if="notification">
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs"/>
    </div>

    <div class="form-npa edit law-edit">
      <div class="position">
        <div class="bg-white p-20">
          <div class="notification-view">
            <div class="notification-view__title">
              {{ notification.title }}
            </div>

            <div class="notification-view__text">
              {{ notification.text }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>        
</template>
<script>

  import LAW from '../model/law'
  import { mapMutations } from 'vuex'
  import { Trans } from '@/plugins/Translation'

  export default {
    name: 'NotificationView',
    data () {
      return {
        notification: null,
        breadcrumbs: []
      }
    },

    mounted () {
      this.fetchData()
    },

    methods: {
      ...mapMutations(['setLoading']),
      generateBreadcrumbs(title) {
        this.breadcrumbs = [
          {text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile'},
          {text: title, disabled: true}
        ]
      },

      fetchData() {
        this.setLoading(true)
        LAW.getNotificationById(this.$route.params.id).then((response) => {
          this.notification = response.data
          this.generateBreadcrumbs(this.notification.title) 
          this.setLoading(false)
        })
      }
    },
  }
</script>
<style lang="scss">
  .notification-view {
    &__title {
      font-size: 20px;
      font-weight: 600;
      padding: 10px 0px;
    }
  }
</style>